export enum LanguageStyleEnum {
    STANDARD = 'STANDARD',
    SIMPLE = 'SIMPLE',
    EASY = 'EASY',
    CUSTOM = 'CUSTOM'
}
